export default __webpack_public_path__ + "static/microscopy-export-166a9dca30c773fdfb4d9aed1ed3db3a.png";